import { useEffect } from 'react';
import { useAuth } from './useAuth';
import { useWorkspace } from './useWorkspace';
import { setUserProperties, setUserId, clearUserId } from '../lib/analytics';

/** Sets user_id and user-level properties. Runs inside AuthProvider. */
export function useAnalyticsIdentify(): void {
  const { user } = useAuth();

  useEffect(() => {
    const measurementId = import.meta.env.VITE_GA4_MEASUREMENT_ID;

    if (!user) {
      // Clear user_id on logout to prevent contaminating anonymous events
      if (measurementId) {
        clearUserId(measurementId);
      }
      return;
    }

    if (measurementId) {
      setUserId(measurementId, user.userId);
    }

    setUserProperties({
      user_plan: user.plan,
      workspace_count: user.workspaceCount,
      is_beta_user: String(user.featureFlags?.premiumTempUnlocked ?? false),
    });
  }, [user?.userId, user?.plan, user?.workspaceCount, user?.featureFlags?.premiumTempUnlocked]);
}

/** Sets workspace-level properties. Must run inside WorkspaceProvider. */
export function useAnalyticsWorkspaceProps(): void {
  const { currentWorkspace } = useWorkspace();

  useEffect(() => {
    setUserProperties({
      has_stripe_connected: String(currentWorkspace?.stripeConnected ?? false),
    });
  }, [currentWorkspace?.stripeConnected]);
}
